
<form [formGroup]="form" class="grid grid-cols-12 gap-4">

  <app-trip-dropdown class="col-span-12" [trips]="trips" [showGroupName]="true" formControlName="trip"></app-trip-dropdown>
  @if (showActionButtons && linkMode === 'link') {
    <button type="button" (click)="linkTrip()">Link</button>
  }
  @if (showActionButtons && linkMode === 'unlink') {
    <button type="button" (click)="unlinkTrip()">Unlink</button>
  }
</form>